import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'

type OptionConstructorArgs = ConstructorArgs<() => Option>

export class Option extends BaseRecord {
    readonly recordType = 'option'

    label?: string
    seqnum?: number
    group?: string
    subtitle?: string
    enabled: boolean = true
    image?: JSX.Element

    constructor(
        data?: Partial<OptionConstructorArgs>,
        params?: {
            id?: string
            label?: string
            group?: string
            subtitle?: string
            image?: JSX.Element
            enabled?: boolean
            seqnum?: number
        }
    ) {
        super(data)
        if (!data) {
            this.id = params?.id
            this.label = params?.label
            this.group = params?.group
            this.subtitle = params?.subtitle
            this.seqnum = params?.seqnum
            if (params?.image !== undefined) this.image = params.image
            if (params?.enabled !== undefined) this.enabled = params.enabled
            return
        }

        this.label = data.label ?? undefined
        this.seqnum = this.propertyFromIntArg(data.seqnum)
        this.group = data.group ?? undefined
        this.subtitle = data.subtitle ?? undefined
        this.enabled = data.enabled ?? false
        this.image = data.image ?? undefined
    }

    clone(overrides?: Partial<OptionConstructorArgs>): Option {
        return new Option({ ...this.serializeForClone(), ...overrides })
    }

    static findOption(id: string | undefined, strings: Option[]): Option | undefined {
        if (id === undefined) id = ''
        for (let op of strings) {
            if (op.id === id) {
                return op
            }
        }
        return undefined
    }

    compareTo(another: any): number {
        let result = 0
        if (another instanceof Option) {
            const v1 = this.seqnum ?? 0
            const v2 = another.seqnum ?? 0
            result = v1 < v2 ? -1 : v1 === v2 ? 0 : 1
        }
        return result
    }

    jsonObject(): any {
        const dict = super.jsonObject()
        dict['label'] = this.label
        dict['seqnum'] = this.seqnum ?? ''
        return dict
    }
}
